export default "__VITE_ASSET__CJ_5bHLy__"